import type { LanguagesPairSideFilter } from '@fiverr-private/listing_types';

export const DEFAULT_LANGUAGE_PAIR_OPTIONS = { fromOptions: [], toOptions: [] };

export interface ExplicitLanguagePairProps {
    filters: LanguagesPairSideFilter[];
}
